import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22index.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:%22./inter-latin.woff2%22,%22weight%22:%22100%20900%22,%22display%22:%22swap%22,%22fallback%22:[%22-apple-system%22,%22system-ui%22,%22BlinkMacSystemFont%22,%22Helvetica%22,%22Arial%22,%22Segoe%20UI%22,%22Roboto%22,%22sans-serif%22]}],%22variableName%22:%22inter%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'inter', 'inter Fallback', -apple-system, system-ui, BlinkMacSystemFont, Helvetica, Arial, Segoe UI, Roboto, sans-serif",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
